export const getHreflangLinks = (
  locale: string,
  skUrlVersion: string,
  enUrlVersion: string
) => {
  const {
    public: { BASE_APP_URL },
  } = useRuntimeConfig()

  return [
    {
      key: 'langSk',
      rel: 'alternate',
      hreflang: 'sk',
      href: BASE_APP_URL + skUrlVersion,
    },
    {
      key: 'langEn',
      rel: 'alternate',
      hreflang: 'en',
      href: BASE_APP_URL + enUrlVersion,
    },
    {
      key: 'default',
      rel: 'alternate',
      hreflang: 'x-default',
      href: BASE_APP_URL + (locale === 'sk' ? skUrlVersion : enUrlVersion),
    },
  ]
}
